module.exports = __webpack_public_path__ + "03_very_short_grey.6874cd29.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_very_short_grey.png
// module id = hC0A
// module chunks = 0